import { daoPut } from 'mrf/Dao';
import { useFormFullSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';
import { FormContext } from 'mrf/view/FormCRUD';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfirmationModal from 'mrf/view/ConfirmationModal';
import PropTypes from 'prop-types';

export default function UserCountry({ userId }) {
    const { t } = useTranslation();
    const user = useSelector(state => state?.resources?.users?.byId?.[userId]);
    const context = useFormSelector({ resource: 'userCountryForm' });
    const { data, set } = useFormFullSelector(context);
    const country = useSelector(state => state?.resources?.countries?.byId?.[data?.countryId]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingCountryId, setPendingCountryId] = useState(null);

    useEffect(() => {
        set({ countryId: user?.countryId });
    }, [user?.countryId]); // eslint-disable-line

    useEffect(() => {
        if (!data?.countryId || data.countryId === user?.countryId) {
            return;
        }
        setPendingCountryId(data.countryId);
        setIsModalOpen(true);
    }, [data?.countryId]); // eslint-disable-line

    const handleConfirm = () => {
        setIsModalOpen(false);

        daoPut(`/api/users/${userId}/country`, { countryId: pendingCountryId });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        set({ countryId: user?.countryId });
    };

    return (
        <FormContext.Provider value={context}>
            <FetcherObjectSelect
                label='Country'
                field='countryId'
                resource='countries'
                displayAttribute='name'
            />
            <ConfirmationModal
                isOpen={isModalOpen}
                onCancel={handleCancel}
                onConfirm={handleConfirm}
                title={t('Confirm Save')}
                message={t("Do you really want to change country to {{country}}?", {country: country?.name || ''})}
            />
        </FormContext.Provider>
    );
}

UserCountry.propTypes = {
    userId: PropTypes.string.isRequired,
};